import { render, staticRenderFns } from "./grievance.vue?vue&type=template&id=2586fa66&"
import script from "./grievance.vue?vue&type=script&lang=js&"
export * from "./grievance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports